import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { AirwallexRecipient } from './airwallex-recipient.entity';

export class CreateAirwallexRecipientDto extends Omit(AirwallexRecipient, [...BaseEntityFieldsArray, 'accountId'], ['providerId']) {
    providerId?: string;
}
